import React from "react";
import { Menu, MenuItem, Box, Typography } from "@mui/material";
import { Check } from "@mui/icons-material";

const priorityOptions = [
  { label: "High", value: "High", color: "#DC2626", bg: "#FEE2E2" },
  { label: "Medium", value: "Medium", color: "#D97706", bg: "#FEF3C7" },
  { label: "Low", value: "Low", color: "#64748B", bg: "#E2E8F0" },
];

const PriorityMenu = ({ anchorEl, open, onClose, currentPriority, onSelect }) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "10px",
          mt: 1,
          minWidth: 140,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          border: "1px solid #E5E7EB",
          py: 0.5,
        },
      }}
    >
      {priorityOptions.map((option) => {
        const isSelected = currentPriority?.toLowerCase() === option.value.toLowerCase();
        return (
          <MenuItem
            key={option.value}
            onClick={() => {
              onSelect(option.value);
              onClose();
            }}
            sx={{
              fontSize: 13,
              py: 1,
              px: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              "&:hover": {
                bgcolor: "#F8FAFC",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  bgcolor: option.color,
                }}
              />
              <Typography sx={{ fontSize: 13, fontWeight: isSelected ? 600 : 400 }}>
                {option.label}
              </Typography>
            </Box>
            {isSelected && (
              <Check sx={{ fontSize: 16, color: "#7C3AED" }} />
            )}
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default PriorityMenu;
